import { CheckBoxFieldv2, VerticalDivider } from '@labrav/react-components'
import { Divider } from '@mui/material'
import { FormikProps } from 'formik'
import { get } from 'lodash'

import type { OfferRecipients } from '../../../modules/privateOffer/reducer'
import { useStyles } from './RecipientCheckBoxListItem.styles'

export const RecipientCheckBoxListItem = ({
  keyName,
  formik,
  recipient,
  hideBorder = false,
  showName = false,
  handleChange,
}: {
  keyName: string
  formik?: FormikProps<Record<string, unknown>>
  recipient: OfferRecipients
  hideBorder: boolean
  showName?: boolean
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const { classes } = useStyles()
  const value = formik ? get(formik.values, keyName) : undefined
  return (
    <>
      <CheckBoxFieldv2
        classNames={classes.checkBox}
        keyName={keyName}
        title={
          <div
            className={classes.recipientWrapper}
            data-testid={'recipient-item'}
          >
            {!showName && (
              <div className={classes.title} data-testid={'recipient-name'}>
                {`${recipient?.firstName || ''} ${recipient?.lastName || ''}`.trim()}
              </div>
            )}
            {get(recipient, 'name') && showName && (
              <>
                <VerticalDivider height="24px" />
                <div className={classes.value} data-testid={'recipient-name'}>
                  {recipient?.name}
                </div>
              </>
            )}
            {get(recipient, 'title') && (
              <>
                <VerticalDivider height="24px" />
                <div className={classes.value} data-testid={'recipient-title'}>
                  {recipient?.title}
                </div>
              </>
            )}
            <VerticalDivider height="24px" />
            <div className={classes.value} data-testid={'recipient-value'}>
              {recipient?.email}
            </div>
          </div>
        }
        value={!!value}
        onChangeBox={formik?.handleChange || handleChange}
      />
      {!hideBorder && <Divider className={classes.divider} />}
    </>
  )
}
